import { render, staticRenderFns } from "./BlockType10.vue?vue&type=template&id=56971769&scoped=true"
import script from "./BlockType10.vue?vue&type=script&lang=ts"
export * from "./BlockType10.vue?vue&type=script&lang=ts"
import style0 from "./BlockType10.vue?vue&type=style&index=0&id=56971769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56971769",
  null
  
)

export default component.exports